<template>
  <CollapseSection
    title="Seguradoras habilitadas"
    :expanded="expanded"
    :disabled="disabled"
    :loading="loading"
    section-id="seguradoras_habilitadas"
    @toggleSection="$emit('toggleSection')"
  >
    
    <div v-if="alertMessage">
        <b-alert show :variant="alertVariant">{{ alertMessage }}</b-alert>
    </div>

    <p>Selecione as seguradoras habilitadas para este tomador</p>

    <div class="d-flex flex-wrap gap-3" v-if="!editable">
      <div class="card card-body p-3 shadow border"
        v-for="insurer in selectedInsurers" :key="insurer.identifier"
        v-b-tooltip.hover.html
        :title="getHtmlEmptyTooltipInsurer(insurer)"
        style="flex: 0 0 150px;">
          <img :src="insurer.icon" alt="logo" class="logo-seguradora">
      </div>
    </div>

    <div class="d-flex flex-wrap gap-3" v-if="editable">
      <div class="card card-body card-seguradora-habilitada enabled"
        v-for="insurer in insurerList" :key="insurer.identifier"
        style="flex: 0 0 400px;">
          <img :src="insurer.icon" alt="logo" class="logo-seguradora">
          <div class="">
              <div class="custom-control custom-switch">
                  <input data-enabled type="checkbox" class="custom-control-input d-none"
                    :id="'switch-' + insurer.identifier" :value="insurer.identifier" v-model="insurerEnableds"
                    @change="toogleInsurerEnabled(insurer.identifier)"
                  >
                  <label class="custom-control-label" :for="'switch-' + insurer.identifier">{{ isInsurerSelected(insurer.identifier) ? 'Habilitada' : 'Desativada' }}</label>
              </div>
              <div class="enabled-inputs">
                  <button type="button" @click="openEditModal(insurer)"
                    v-if="hasInsurerConfiguration(insurer.identifier)"
                    class="text-secondary position-absolute border-0 bg-transparent p-2" style="top: 0; right: 0; margin-inline-end: 3px;">
                      <i class="fa fa-pen" data-toggle="modal" data-target="#modal-seguradora-habilitada"></i>
                  </button>
                  <div class="border p-2 mt-2" v-if="hasConfiguration(insurer.identifier)">
                      <table>
                          <tbody>
                              <tr>
                                  <td class="text-center"><i class="fa fa-check fa-fw"></i></td>
                                  <td class="font-12 px-2">{{ getConfiguration(insurer.identifier)?.single_invoice ? 'Fatura única' : 'Boleto' }}</td>
                              </tr>
                              <tr v-if="getConfiguration(insurer.identifier).days_due_date_invoice">
                                  <td class="text-center"><strong>{{ getConfiguration(insurer.identifier)?.days_due_date_invoice }}</strong></td>
                                  <td class="font-12 px-2">dias para o vencimento do boleto</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
    </div>
    
    <div class="modal">
      <b-modal
        id="show-modal-edit-insurer-configuration"
        ref="showModalEditInsurerConfiguration"
        size="md"
        class="mt-4"
        centered
        hide-footer
      >
        <template #modal-title>Editar seguradora habilitada</template>
        
          <div v-if="alertMessage" class="list-error-configuration mb-4">
              <div class="alert-custom alert-danger-custom list-errors-custom">
                <ul class="list-errors mb-0">
                  <li v-for="(er, key) in listErrorMessage" :key="key">
                    <small>{{ er[0] }}</small></li>
                </ul>
              </div>
          </div>

        <div class="card mb-3">
    
          <form v-if="insurerSelected">
              <div class="d-flex flex-row gap-5 align-items-center mb-4">
                  <img :src="insurerSelected.icon" alt="" style="max-width: 150px; max-height: 50px; object-fit: contain; object-position: center center;">
                  <div v-if="insurerHasConfigurationSelected.hasSingleInvoice">
                      <div class="form-group d-flex justify-content-between align-items-center mb-0">
                          <div class="custom-control custom-switch m-0">
                              <input type="checkbox" class="custom-control-input" id="faturaUnica" @change="onChangeCheckSingleInvoice"
                                v-model="insurerConfigurationSelected.single_invoice">
                              <label class="custom-control-label" for="faturaUnica">Fatura única</label>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="form-group" v-if="insurerHasConfigurationSelected.hasDaysDueDateInvoice && !insurerConfigurationSelected.single_invoice">
                  <label for="diasBoleto" class="dbo-ui">Dias para o vencimento do boleto</label>
                  <input type="text" class="form-control" id="diasBoleto"
                      v-model="insurerConfigurationSelected.days_due_date_invoice"
                      v-mask="'##'"
                      min="0" max="30" placeholder="Dias para o vencimento do boleto">
              </div>
          </form>
          
        </div>
        
        <div class="row border-top py-4">
          <div class="col-12 col-lg-12 d-flex justify-content-end">
            <button class="btn btn-secondary mr-2"
              @click="closeEditModal()"
            >
              <span class="d-none d-md-inline-block"><i class="fa fa-times mr-1"></i> Cancelar</span>
            </button>

            <button class="btn btn-primary"
              @click="storeInsurerConfiguration()"
            >
              <i class="fa fa-check mr-1"></i> Salvar
            </button>
          </div>
        </div>

      </b-modal>
    </div>

  </CollapseSection>
</template>

<script>
import { mask } from "vue-the-mask";
import { CollapseSection } from '@/components';
import commomsHelperMixin from "@/mixins/commomsHelper";
import commonsService from "@/services/commons";
import economicGroupService from "@/services/economic-group";

export default {
  components: { CollapseSection },
  props: {
    expanded: Boolean,
    disabled: Boolean,
    economicGroupID: String,
    editable: { type: Boolean, default: false }
  },
  directives: { mask, },
  mixins: [commomsHelperMixin],
  data: () => ({
    loading: false,
    insurerList: [],
    insurerEnableds: [],
    insurerConfigurations: [],
    insurerSelected: {},
    insurerConfigurationSelected: {
      'insurer_identifier': '',
      'days_due_date_invoice': null,
      'single_invoice': false
    },
    listErrorMessage: [],
    insurersHaveConfiguration: [
      { insurer: 'junto-seguros', hasSingleInvoice: true, hasDaysDueDateInvoice: true },
      { insurer: 'pottencial', hasSingleInvoice: true, hasDaysDueDateInvoice: true },
      { insurer: 'ezze', hasSingleInvoice: true },
    ],
    insurerHasConfigurationSelected: {
      'days_due_date_invoice': false,
      'single_invoice': false
    },
  }),
  created() {
    this.resetAlert();
    if (this.expanded && this.economicGroupID) {
      this.findData();
    }
  },
  methods: {
    findData() {
        this.getInsurers();
        this.getEnabledInsurers();
        this.getEconomicGroupInsurerConfigurations();
    },
    hasConfiguration(insurerIdentifier) {
        return this.insurerConfigurations.some(config => 
            config.insurer_identifier === insurerIdentifier
        );
    },
    getConfiguration(insurerIdentifier) {
        return this.insurerConfigurations.find(config =>
            config.insurer_identifier === insurerIdentifier
        ) || null;
    },
    getInsurers() {
      this.loading = true;
      commonsService
        .getAllInsurersWithIntegration()
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.insurerList = response.data;
        })
        .catch((error) => {
          this.showError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openEditModal(insurerIdentifier) {
      this.insurerSelected = insurerIdentifier;
      this.insurerHasConfigurationSelected = this.getHasInsurerConfiguration(insurerIdentifier.identifier)
      if (this.hasConfiguration(insurerIdentifier.identifier)) {
        this.insurerConfigurationSelected = this.getConfiguration(insurerIdentifier.identifier);
        
      } else {
        this.clearDataFormConfiguration();
        this.insurerConfigurationSelected.insurer_identifier = insurerIdentifier.identifier;
      }

      this.$refs.showModalEditInsurerConfiguration.show();
    },
    closeEditModal() {
      this.clearDataFormConfiguration();
      this.clearAlerts();
      this.getEconomicGroupInsurerConfigurations();
      this.$refs.showModalEditInsurerConfiguration.hide();
    },
    clearDataFormConfiguration() {
      this.insurerConfigurationSelected = {
        'insurer_identifier': '',
        'days_due_date_invoice': null,
        'single_invoice': false
      }
    },
    getEnabledInsurers() {
      this.loading = true;
      economicGroupService
        .getEnabledInsurers(this.economicGroupID)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.insurerEnableds = response.data;
        })
        .catch(() => {
          this.showError("Não foi possível buscar as seguradoras habilitadas.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toogleInsurerEnabled(insurerIdentifier) {
      this.loading = true;
      economicGroupService
        .toogleInsurerEnabled(this.economicGroupID, insurerIdentifier)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
        })
        .catch(() => {
          this.showError("Não foi possível alterar a seguradora.");
        })
        .finally(() => {
          this.loading = false;
          this.getEnabledInsurers();
          this.clearAlerts();
        });

    },
    storeInsurerConfiguration() {
      this.loading = true;
      economicGroupService
        .storeInsurerConfiguration(this.economicGroupID, this.insurerConfigurationSelected)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.closeEditModal();
        })
        .catch((err) => {
          this.listErrorMessage = this.showListErrors(err);
          this.showError("Não foi possível salvar as configurações.");
        })
        .finally(() => {
          this.loading = false;
        });

    },
    clearAlerts() {
      this.resetAlert();
      this.listErrorMessage = [];
    },
    getEconomicGroupInsurerConfigurations() {
      this.loading = true;
      economicGroupService
        .getEconomicGroupInsurerConfigurations(this.economicGroupID)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.$nextTick(() => {
            this.insurerConfigurations = response.data;
          });
        })
        .catch(() => {
          this.showError("Não foi possível buscar as configurações desse tomador.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getHtmlEmptyTooltipInsurer(insurer) {
        var configurationText = '';
        if (this.hasConfiguration(insurer.identifier)) {
          configurationText += (this.getConfiguration(insurer.identifier)?.single_invoice ? '- Fatura única' : '- Boleto') + '<br/>'
            + (
                this.getConfiguration(insurer.identifier).days_due_date_invoice ?
                '- ' + this.getConfiguration(insurer.identifier)?.days_due_date_invoice + ' dias para o vencimento do boleto'
                : ''
            );

        }
        return '- Tem integração<br>' + configurationText;
    },
    isInsurerSelected(identifier) {
      return this.insurerEnableds.includes(identifier);
    },
    hasInsurerConfiguration(identifier) {
      return this.insurersHaveConfiguration.some(item => 
          item.insurer === identifier &&
          (item.hasDaysDueDateInvoice || item.hasSingleInvoice)
      );
    },
    getHasInsurerConfiguration(identifier) {
      return this.insurersHaveConfiguration.find(item => item.insurer === identifier);
    },
    onChangeCheckSingleInvoice() {
      if (this.insurerConfigurationSelected.single_invoice) {
        this.insurerConfigurationSelected.days_due_date_invoice = null;
      }
    }
  },
  computed: {
    selectedInsurers() {
      if (!this.insurerEnableds || !this.insurerList) return [];
      return this.insurerList.filter(insurer =>
        this.insurerEnableds.includes(insurer.identifier)
      )
    }
  },
  watch: {
    expanded: function (value) {
      if (value) {
        this.resetAlert();
        this.findData();
      }
    },
  }
}
</script>
<style scoped>
.list-error-configuration .alert-custom::before { display: none !important; }
.list-error-configuration .alert-custom ul { padding-left: 0px !important; }
.logo-seguradora { width: auto; }
</style>
